// source: childreporting/childreporting.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var authz_annotations_pb = require('../authz/annotations_pb.js');
goog.object.extend(proto, authz_annotations_pb);
var artifact_artifact_pb = require('../artifact/artifact_pb.js');
goog.object.extend(proto, artifact_artifact_pb);
var audit_auditbot_pb = require('../audit/auditbot_pb.js');
goog.object.extend(proto, audit_auditbot_pb);
var common_model_pb = require('../common/model_pb.js');
goog.object.extend(proto, common_model_pb);
goog.exportSymbol('proto.childreporting.ControlExportCitation', null, global);
goog.exportSymbol('proto.childreporting.ControlExportRow', null, global);
goog.exportSymbol('proto.childreporting.ControlExportSnapshot', null, global);
goog.exportSymbol('proto.childreporting.ControlExportTest', null, global);
goog.exportSymbol('proto.childreporting.ControlExportTestResult', null, global);
goog.exportSymbol('proto.childreporting.FrameworkRequirements', null, global);
goog.exportSymbol('proto.childreporting.GetChildControlExportsResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.childreporting.GetChildControlExportsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.childreporting.GetChildControlExportsResponse.repeatedFields_, null);
};
goog.inherits(proto.childreporting.GetChildControlExportsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.childreporting.GetChildControlExportsResponse.displayName = 'proto.childreporting.GetChildControlExportsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.childreporting.ControlExportSnapshot = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.childreporting.ControlExportSnapshot.repeatedFields_, null);
};
goog.inherits(proto.childreporting.ControlExportSnapshot, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.childreporting.ControlExportSnapshot.displayName = 'proto.childreporting.ControlExportSnapshot';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.childreporting.ControlExportRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.childreporting.ControlExportRow.repeatedFields_, null);
};
goog.inherits(proto.childreporting.ControlExportRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.childreporting.ControlExportRow.displayName = 'proto.childreporting.ControlExportRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.childreporting.FrameworkRequirements = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.childreporting.FrameworkRequirements.repeatedFields_, null);
};
goog.inherits(proto.childreporting.FrameworkRequirements, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.childreporting.FrameworkRequirements.displayName = 'proto.childreporting.FrameworkRequirements';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.childreporting.ControlExportTest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.childreporting.ControlExportTest.repeatedFields_, null);
};
goog.inherits(proto.childreporting.ControlExportTest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.childreporting.ControlExportTest.displayName = 'proto.childreporting.ControlExportTest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.childreporting.ControlExportTestResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.childreporting.ControlExportTestResult.repeatedFields_, null);
};
goog.inherits(proto.childreporting.ControlExportTestResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.childreporting.ControlExportTestResult.displayName = 'proto.childreporting.ControlExportTestResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.childreporting.ControlExportCitation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.childreporting.ControlExportCitation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.childreporting.ControlExportCitation.displayName = 'proto.childreporting.ControlExportCitation';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.childreporting.GetChildControlExportsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.childreporting.GetChildControlExportsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.childreporting.GetChildControlExportsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.childreporting.GetChildControlExportsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.childreporting.GetChildControlExportsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    snapshotsList: jspb.Message.toObjectList(msg.getSnapshotsList(),
    proto.childreporting.ControlExportSnapshot.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.childreporting.GetChildControlExportsResponse}
 */
proto.childreporting.GetChildControlExportsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.childreporting.GetChildControlExportsResponse;
  return proto.childreporting.GetChildControlExportsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.childreporting.GetChildControlExportsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.childreporting.GetChildControlExportsResponse}
 */
proto.childreporting.GetChildControlExportsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.childreporting.ControlExportSnapshot;
      reader.readMessage(value,proto.childreporting.ControlExportSnapshot.deserializeBinaryFromReader);
      msg.addSnapshots(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.childreporting.GetChildControlExportsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.childreporting.GetChildControlExportsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.childreporting.GetChildControlExportsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.childreporting.GetChildControlExportsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSnapshotsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.childreporting.ControlExportSnapshot.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ControlExportSnapshot snapshots = 1;
 * @return {!Array<!proto.childreporting.ControlExportSnapshot>}
 */
proto.childreporting.GetChildControlExportsResponse.prototype.getSnapshotsList = function() {
  return /** @type{!Array<!proto.childreporting.ControlExportSnapshot>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.childreporting.ControlExportSnapshot, 1));
};


/**
 * @param {!Array<!proto.childreporting.ControlExportSnapshot>} value
 * @return {!proto.childreporting.GetChildControlExportsResponse} returns this
*/
proto.childreporting.GetChildControlExportsResponse.prototype.setSnapshotsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.childreporting.ControlExportSnapshot=} opt_value
 * @param {number=} opt_index
 * @return {!proto.childreporting.ControlExportSnapshot}
 */
proto.childreporting.GetChildControlExportsResponse.prototype.addSnapshots = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.childreporting.ControlExportSnapshot, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.childreporting.GetChildControlExportsResponse} returns this
 */
proto.childreporting.GetChildControlExportsResponse.prototype.clearSnapshotsList = function() {
  return this.setSnapshotsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.childreporting.ControlExportSnapshot.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.childreporting.ControlExportSnapshot.prototype.toObject = function(opt_includeInstance) {
  return proto.childreporting.ControlExportSnapshot.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.childreporting.ControlExportSnapshot} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.childreporting.ControlExportSnapshot.toObject = function(includeInstance, msg) {
  var f, obj = {
    schemaVersion: jspb.Message.getFieldWithDefault(msg, 1, 0),
    accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    orgName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    reportDate: jspb.Message.getFieldWithDefault(msg, 4, ""),
    generatedAt: jspb.Message.getFieldWithDefault(msg, 5, 0),
    rowsList: jspb.Message.toObjectList(msg.getRowsList(),
    proto.childreporting.ControlExportRow.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.childreporting.ControlExportSnapshot}
 */
proto.childreporting.ControlExportSnapshot.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.childreporting.ControlExportSnapshot;
  return proto.childreporting.ControlExportSnapshot.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.childreporting.ControlExportSnapshot} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.childreporting.ControlExportSnapshot}
 */
proto.childreporting.ControlExportSnapshot.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSchemaVersion(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setReportDate(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setGeneratedAt(value);
      break;
    case 6:
      var value = new proto.childreporting.ControlExportRow;
      reader.readMessage(value,proto.childreporting.ControlExportRow.deserializeBinaryFromReader);
      msg.addRows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.childreporting.ControlExportSnapshot.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.childreporting.ControlExportSnapshot.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.childreporting.ControlExportSnapshot} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.childreporting.ControlExportSnapshot.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSchemaVersion();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrgName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getReportDate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getGeneratedAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getRowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.childreporting.ControlExportRow.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 schema_version = 1;
 * @return {number}
 */
proto.childreporting.ControlExportSnapshot.prototype.getSchemaVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.childreporting.ControlExportSnapshot} returns this
 */
proto.childreporting.ControlExportSnapshot.prototype.setSchemaVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.childreporting.ControlExportSnapshot.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.ControlExportSnapshot} returns this
 */
proto.childreporting.ControlExportSnapshot.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string org_name = 3;
 * @return {string}
 */
proto.childreporting.ControlExportSnapshot.prototype.getOrgName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.ControlExportSnapshot} returns this
 */
proto.childreporting.ControlExportSnapshot.prototype.setOrgName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string report_date = 4;
 * @return {string}
 */
proto.childreporting.ControlExportSnapshot.prototype.getReportDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.ControlExportSnapshot} returns this
 */
proto.childreporting.ControlExportSnapshot.prototype.setReportDate = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 generated_at = 5;
 * @return {number}
 */
proto.childreporting.ControlExportSnapshot.prototype.getGeneratedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.childreporting.ControlExportSnapshot} returns this
 */
proto.childreporting.ControlExportSnapshot.prototype.setGeneratedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * repeated ControlExportRow rows = 6;
 * @return {!Array<!proto.childreporting.ControlExportRow>}
 */
proto.childreporting.ControlExportSnapshot.prototype.getRowsList = function() {
  return /** @type{!Array<!proto.childreporting.ControlExportRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.childreporting.ControlExportRow, 6));
};


/**
 * @param {!Array<!proto.childreporting.ControlExportRow>} value
 * @return {!proto.childreporting.ControlExportSnapshot} returns this
*/
proto.childreporting.ControlExportSnapshot.prototype.setRowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.childreporting.ControlExportRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.childreporting.ControlExportRow}
 */
proto.childreporting.ControlExportSnapshot.prototype.addRows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.childreporting.ControlExportRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.childreporting.ControlExportSnapshot} returns this
 */
proto.childreporting.ControlExportSnapshot.prototype.clearRowsList = function() {
  return this.setRowsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.childreporting.ControlExportRow.repeatedFields_ = [6,7,13,16,17,18];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.childreporting.ControlExportRow.prototype.toObject = function(opt_includeInstance) {
  return proto.childreporting.ControlExportRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.childreporting.ControlExportRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.childreporting.ControlExportRow.toObject = function(includeInstance, msg) {
  var f, obj = {
    controlModelId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    objective: jspb.Message.getFieldWithDefault(msg, 3, ""),
    notes: jspb.Message.getFieldWithDefault(msg, 4, ""),
    procedure: jspb.Message.getFieldWithDefault(msg, 5, ""),
    policiesList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    departmentsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    status: jspb.Message.getFieldWithDefault(msg, 8, ""),
    responsibility: jspb.Message.getFieldWithDefault(msg, 9, 0),
    notApplicableReason: jspb.Message.getFieldWithDefault(msg, 10, ""),
    vendor: jspb.Message.getFieldWithDefault(msg, 11, ""),
    ownerEmail: jspb.Message.getFieldWithDefault(msg, 12, ""),
    assigneeEmailsList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f,
    requiredEvidence: jspb.Message.getFieldWithDefault(msg, 14, ""),
    testProcedures: jspb.Message.getFieldWithDefault(msg, 15, ""),
    risksList: (f = jspb.Message.getRepeatedField(msg, 16)) == null ? undefined : f,
    frameworksList: jspb.Message.toObjectList(msg.getFrameworksList(),
    proto.childreporting.FrameworkRequirements.toObject, includeInstance),
    testsList: jspb.Message.toObjectList(msg.getTestsList(),
    proto.childreporting.ControlExportTest.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.childreporting.ControlExportRow}
 */
proto.childreporting.ControlExportRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.childreporting.ControlExportRow;
  return proto.childreporting.ControlExportRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.childreporting.ControlExportRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.childreporting.ControlExportRow}
 */
proto.childreporting.ControlExportRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setControlModelId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setObjective(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setProcedure(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addPolicies(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addDepartments(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {!proto.common.RESPONSIBILITY} */ (reader.readEnum());
      msg.setResponsibility(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotApplicableReason(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendor(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerEmail(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.addAssigneeEmails(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequiredEvidence(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setTestProcedures(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.addRisks(value);
      break;
    case 17:
      var value = new proto.childreporting.FrameworkRequirements;
      reader.readMessage(value,proto.childreporting.FrameworkRequirements.deserializeBinaryFromReader);
      msg.addFrameworks(value);
      break;
    case 18:
      var value = new proto.childreporting.ControlExportTest;
      reader.readMessage(value,proto.childreporting.ControlExportTest.deserializeBinaryFromReader);
      msg.addTests(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.childreporting.ControlExportRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.childreporting.ControlExportRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.childreporting.ControlExportRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.childreporting.ControlExportRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlModelId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getObjective();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getProcedure();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPoliciesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getDepartmentsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getResponsibility();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getNotApplicableReason();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getVendor();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getOwnerEmail();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAssigneeEmailsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      13,
      f
    );
  }
  f = message.getRequiredEvidence();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getTestProcedures();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getRisksList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      16,
      f
    );
  }
  f = message.getFrameworksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      17,
      f,
      proto.childreporting.FrameworkRequirements.serializeBinaryToWriter
    );
  }
  f = message.getTestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      18,
      f,
      proto.childreporting.ControlExportTest.serializeBinaryToWriter
    );
  }
};


/**
 * optional string control_model_id = 1;
 * @return {string}
 */
proto.childreporting.ControlExportRow.prototype.getControlModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.setControlModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.childreporting.ControlExportRow.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string objective = 3;
 * @return {string}
 */
proto.childreporting.ControlExportRow.prototype.getObjective = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.setObjective = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string notes = 4;
 * @return {string}
 */
proto.childreporting.ControlExportRow.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string procedure = 5;
 * @return {string}
 */
proto.childreporting.ControlExportRow.prototype.getProcedure = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.setProcedure = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated string policies = 6;
 * @return {!Array<string>}
 */
proto.childreporting.ControlExportRow.prototype.getPoliciesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.setPoliciesList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.addPolicies = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.clearPoliciesList = function() {
  return this.setPoliciesList([]);
};


/**
 * repeated string departments = 7;
 * @return {!Array<string>}
 */
proto.childreporting.ControlExportRow.prototype.getDepartmentsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.setDepartmentsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.addDepartments = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.clearDepartmentsList = function() {
  return this.setDepartmentsList([]);
};


/**
 * optional string status = 8;
 * @return {string}
 */
proto.childreporting.ControlExportRow.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional common.RESPONSIBILITY responsibility = 9;
 * @return {!proto.common.RESPONSIBILITY}
 */
proto.childreporting.ControlExportRow.prototype.getResponsibility = function() {
  return /** @type {!proto.common.RESPONSIBILITY} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.common.RESPONSIBILITY} value
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.setResponsibility = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional string not_applicable_reason = 10;
 * @return {string}
 */
proto.childreporting.ControlExportRow.prototype.getNotApplicableReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.setNotApplicableReason = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string vendor = 11;
 * @return {string}
 */
proto.childreporting.ControlExportRow.prototype.getVendor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.setVendor = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string owner_email = 12;
 * @return {string}
 */
proto.childreporting.ControlExportRow.prototype.getOwnerEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.setOwnerEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * repeated string assignee_emails = 13;
 * @return {!Array<string>}
 */
proto.childreporting.ControlExportRow.prototype.getAssigneeEmailsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 13));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.setAssigneeEmailsList = function(value) {
  return jspb.Message.setField(this, 13, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.addAssigneeEmails = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.clearAssigneeEmailsList = function() {
  return this.setAssigneeEmailsList([]);
};


/**
 * optional string required_evidence = 14;
 * @return {string}
 */
proto.childreporting.ControlExportRow.prototype.getRequiredEvidence = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.setRequiredEvidence = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string test_procedures = 15;
 * @return {string}
 */
proto.childreporting.ControlExportRow.prototype.getTestProcedures = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.setTestProcedures = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * repeated string risks = 16;
 * @return {!Array<string>}
 */
proto.childreporting.ControlExportRow.prototype.getRisksList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 16));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.setRisksList = function(value) {
  return jspb.Message.setField(this, 16, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.addRisks = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 16, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.clearRisksList = function() {
  return this.setRisksList([]);
};


/**
 * repeated FrameworkRequirements frameworks = 17;
 * @return {!Array<!proto.childreporting.FrameworkRequirements>}
 */
proto.childreporting.ControlExportRow.prototype.getFrameworksList = function() {
  return /** @type{!Array<!proto.childreporting.FrameworkRequirements>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.childreporting.FrameworkRequirements, 17));
};


/**
 * @param {!Array<!proto.childreporting.FrameworkRequirements>} value
 * @return {!proto.childreporting.ControlExportRow} returns this
*/
proto.childreporting.ControlExportRow.prototype.setFrameworksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 17, value);
};


/**
 * @param {!proto.childreporting.FrameworkRequirements=} opt_value
 * @param {number=} opt_index
 * @return {!proto.childreporting.FrameworkRequirements}
 */
proto.childreporting.ControlExportRow.prototype.addFrameworks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 17, opt_value, proto.childreporting.FrameworkRequirements, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.clearFrameworksList = function() {
  return this.setFrameworksList([]);
};


/**
 * repeated ControlExportTest tests = 18;
 * @return {!Array<!proto.childreporting.ControlExportTest>}
 */
proto.childreporting.ControlExportRow.prototype.getTestsList = function() {
  return /** @type{!Array<!proto.childreporting.ControlExportTest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.childreporting.ControlExportTest, 18));
};


/**
 * @param {!Array<!proto.childreporting.ControlExportTest>} value
 * @return {!proto.childreporting.ControlExportRow} returns this
*/
proto.childreporting.ControlExportRow.prototype.setTestsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 18, value);
};


/**
 * @param {!proto.childreporting.ControlExportTest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.childreporting.ControlExportTest}
 */
proto.childreporting.ControlExportRow.prototype.addTests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.childreporting.ControlExportTest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.childreporting.ControlExportRow} returns this
 */
proto.childreporting.ControlExportRow.prototype.clearTestsList = function() {
  return this.setTestsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.childreporting.FrameworkRequirements.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.childreporting.FrameworkRequirements.prototype.toObject = function(opt_includeInstance) {
  return proto.childreporting.FrameworkRequirements.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.childreporting.FrameworkRequirements} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.childreporting.FrameworkRequirements.toObject = function(includeInstance, msg) {
  var f, obj = {
    frameworkName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    requirementNamesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.childreporting.FrameworkRequirements}
 */
proto.childreporting.FrameworkRequirements.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.childreporting.FrameworkRequirements;
  return proto.childreporting.FrameworkRequirements.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.childreporting.FrameworkRequirements} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.childreporting.FrameworkRequirements}
 */
proto.childreporting.FrameworkRequirements.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrameworkName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addRequirementNames(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.childreporting.FrameworkRequirements.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.childreporting.FrameworkRequirements.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.childreporting.FrameworkRequirements} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.childreporting.FrameworkRequirements.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrameworkName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRequirementNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string framework_name = 1;
 * @return {string}
 */
proto.childreporting.FrameworkRequirements.prototype.getFrameworkName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.FrameworkRequirements} returns this
 */
proto.childreporting.FrameworkRequirements.prototype.setFrameworkName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string requirement_names = 2;
 * @return {!Array<string>}
 */
proto.childreporting.FrameworkRequirements.prototype.getRequirementNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.childreporting.FrameworkRequirements} returns this
 */
proto.childreporting.FrameworkRequirements.prototype.setRequirementNamesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.childreporting.FrameworkRequirements} returns this
 */
proto.childreporting.FrameworkRequirements.prototype.addRequirementNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.childreporting.FrameworkRequirements} returns this
 */
proto.childreporting.FrameworkRequirements.prototype.clearRequirementNamesList = function() {
  return this.setRequirementNamesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.childreporting.ControlExportTest.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.childreporting.ControlExportTest.prototype.toObject = function(opt_includeInstance) {
  return proto.childreporting.ControlExportTest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.childreporting.ControlExportTest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.childreporting.ControlExportTest.toObject = function(includeInstance, msg) {
  var f, obj = {
    testName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    result: jspb.Message.getFieldWithDefault(msg, 2, 0),
    reason: jspb.Message.getFieldWithDefault(msg, 3, ""),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 4, 0),
    artifactId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    detailsList: jspb.Message.toObjectList(msg.getDetailsList(),
    proto.childreporting.ControlExportTestResult.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.childreporting.ControlExportTest}
 */
proto.childreporting.ControlExportTest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.childreporting.ControlExportTest;
  return proto.childreporting.ControlExportTest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.childreporting.ControlExportTest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.childreporting.ControlExportTest}
 */
proto.childreporting.ControlExportTest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTestName(value);
      break;
    case 2:
      var value = /** @type {!proto.audit.AUDIT_RESULT} */ (reader.readEnum());
      msg.setResult(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setArtifactId(value);
      break;
    case 6:
      var value = new proto.childreporting.ControlExportTestResult;
      reader.readMessage(value,proto.childreporting.ControlExportTestResult.deserializeBinaryFromReader);
      msg.addDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.childreporting.ControlExportTest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.childreporting.ControlExportTest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.childreporting.ControlExportTest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.childreporting.ControlExportTest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTestName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getResult();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getArtifactId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDetailsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.childreporting.ControlExportTestResult.serializeBinaryToWriter
    );
  }
};


/**
 * optional string test_name = 1;
 * @return {string}
 */
proto.childreporting.ControlExportTest.prototype.getTestName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.ControlExportTest} returns this
 */
proto.childreporting.ControlExportTest.prototype.setTestName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional audit.AUDIT_RESULT result = 2;
 * @return {!proto.audit.AUDIT_RESULT}
 */
proto.childreporting.ControlExportTest.prototype.getResult = function() {
  return /** @type {!proto.audit.AUDIT_RESULT} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.audit.AUDIT_RESULT} value
 * @return {!proto.childreporting.ControlExportTest} returns this
 */
proto.childreporting.ControlExportTest.prototype.setResult = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string reason = 3;
 * @return {string}
 */
proto.childreporting.ControlExportTest.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.ControlExportTest} returns this
 */
proto.childreporting.ControlExportTest.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 updated_at = 4;
 * @return {number}
 */
proto.childreporting.ControlExportTest.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.childreporting.ControlExportTest} returns this
 */
proto.childreporting.ControlExportTest.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string artifact_id = 5;
 * @return {string}
 */
proto.childreporting.ControlExportTest.prototype.getArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.ControlExportTest} returns this
 */
proto.childreporting.ControlExportTest.prototype.setArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated ControlExportTestResult details = 6;
 * @return {!Array<!proto.childreporting.ControlExportTestResult>}
 */
proto.childreporting.ControlExportTest.prototype.getDetailsList = function() {
  return /** @type{!Array<!proto.childreporting.ControlExportTestResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.childreporting.ControlExportTestResult, 6));
};


/**
 * @param {!Array<!proto.childreporting.ControlExportTestResult>} value
 * @return {!proto.childreporting.ControlExportTest} returns this
*/
proto.childreporting.ControlExportTest.prototype.setDetailsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.childreporting.ControlExportTestResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.childreporting.ControlExportTestResult}
 */
proto.childreporting.ControlExportTest.prototype.addDetails = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.childreporting.ControlExportTestResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.childreporting.ControlExportTest} returns this
 */
proto.childreporting.ControlExportTest.prototype.clearDetailsList = function() {
  return this.setDetailsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.childreporting.ControlExportTestResult.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.childreporting.ControlExportTestResult.prototype.toObject = function(opt_includeInstance) {
  return proto.childreporting.ControlExportTestResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.childreporting.ControlExportTestResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.childreporting.ControlExportTestResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    testString: jspb.Message.getFieldWithDefault(msg, 1, ""),
    determination: jspb.Message.getFieldWithDefault(msg, 2, 0),
    reasoning: jspb.Message.getFieldWithDefault(msg, 3, ""),
    citationsList: jspb.Message.toObjectList(msg.getCitationsList(),
    proto.childreporting.ControlExportCitation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.childreporting.ControlExportTestResult}
 */
proto.childreporting.ControlExportTestResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.childreporting.ControlExportTestResult;
  return proto.childreporting.ControlExportTestResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.childreporting.ControlExportTestResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.childreporting.ControlExportTestResult}
 */
proto.childreporting.ControlExportTestResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTestString(value);
      break;
    case 2:
      var value = /** @type {!proto.artifact.OeControlTestDetermination} */ (reader.readEnum());
      msg.setDetermination(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReasoning(value);
      break;
    case 4:
      var value = new proto.childreporting.ControlExportCitation;
      reader.readMessage(value,proto.childreporting.ControlExportCitation.deserializeBinaryFromReader);
      msg.addCitations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.childreporting.ControlExportTestResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.childreporting.ControlExportTestResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.childreporting.ControlExportTestResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.childreporting.ControlExportTestResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTestString();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDetermination();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getReasoning();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCitationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.childreporting.ControlExportCitation.serializeBinaryToWriter
    );
  }
};


/**
 * optional string test_string = 1;
 * @return {string}
 */
proto.childreporting.ControlExportTestResult.prototype.getTestString = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.ControlExportTestResult} returns this
 */
proto.childreporting.ControlExportTestResult.prototype.setTestString = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional artifact.OeControlTestDetermination determination = 2;
 * @return {!proto.artifact.OeControlTestDetermination}
 */
proto.childreporting.ControlExportTestResult.prototype.getDetermination = function() {
  return /** @type {!proto.artifact.OeControlTestDetermination} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.artifact.OeControlTestDetermination} value
 * @return {!proto.childreporting.ControlExportTestResult} returns this
 */
proto.childreporting.ControlExportTestResult.prototype.setDetermination = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string reasoning = 3;
 * @return {string}
 */
proto.childreporting.ControlExportTestResult.prototype.getReasoning = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.ControlExportTestResult} returns this
 */
proto.childreporting.ControlExportTestResult.prototype.setReasoning = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated ControlExportCitation citations = 4;
 * @return {!Array<!proto.childreporting.ControlExportCitation>}
 */
proto.childreporting.ControlExportTestResult.prototype.getCitationsList = function() {
  return /** @type{!Array<!proto.childreporting.ControlExportCitation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.childreporting.ControlExportCitation, 4));
};


/**
 * @param {!Array<!proto.childreporting.ControlExportCitation>} value
 * @return {!proto.childreporting.ControlExportTestResult} returns this
*/
proto.childreporting.ControlExportTestResult.prototype.setCitationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.childreporting.ControlExportCitation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.childreporting.ControlExportCitation}
 */
proto.childreporting.ControlExportTestResult.prototype.addCitations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.childreporting.ControlExportCitation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.childreporting.ControlExportTestResult} returns this
 */
proto.childreporting.ControlExportTestResult.prototype.clearCitationsList = function() {
  return this.setCitationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.childreporting.ControlExportCitation.prototype.toObject = function(opt_includeInstance) {
  return proto.childreporting.ControlExportCitation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.childreporting.ControlExportCitation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.childreporting.ControlExportCitation.toObject = function(includeInstance, msg) {
  var f, obj = {
    citationType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    evidenceCaption: jspb.Message.getFieldWithDefault(msg, 2, ""),
    relevantDate: jspb.Message.getFieldWithDefault(msg, 3, ""),
    findingSummary: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.childreporting.ControlExportCitation}
 */
proto.childreporting.ControlExportCitation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.childreporting.ControlExportCitation;
  return proto.childreporting.ControlExportCitation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.childreporting.ControlExportCitation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.childreporting.ControlExportCitation}
 */
proto.childreporting.ControlExportCitation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.artifact.OeControlTestCitationType} */ (reader.readEnum());
      msg.setCitationType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceCaption(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRelevantDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFindingSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.childreporting.ControlExportCitation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.childreporting.ControlExportCitation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.childreporting.ControlExportCitation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.childreporting.ControlExportCitation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCitationType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getEvidenceCaption();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRelevantDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFindingSummary();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional artifact.OeControlTestCitationType citation_type = 1;
 * @return {!proto.artifact.OeControlTestCitationType}
 */
proto.childreporting.ControlExportCitation.prototype.getCitationType = function() {
  return /** @type {!proto.artifact.OeControlTestCitationType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.artifact.OeControlTestCitationType} value
 * @return {!proto.childreporting.ControlExportCitation} returns this
 */
proto.childreporting.ControlExportCitation.prototype.setCitationType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string evidence_caption = 2;
 * @return {string}
 */
proto.childreporting.ControlExportCitation.prototype.getEvidenceCaption = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.ControlExportCitation} returns this
 */
proto.childreporting.ControlExportCitation.prototype.setEvidenceCaption = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string relevant_date = 3;
 * @return {string}
 */
proto.childreporting.ControlExportCitation.prototype.getRelevantDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.ControlExportCitation} returns this
 */
proto.childreporting.ControlExportCitation.prototype.setRelevantDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string finding_summary = 4;
 * @return {string}
 */
proto.childreporting.ControlExportCitation.prototype.getFindingSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.childreporting.ControlExportCitation} returns this
 */
proto.childreporting.ControlExportCitation.prototype.setFindingSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


goog.object.extend(exports, proto.childreporting);
